export const SAVE_ABILITIES = ['str', 'dex', 'con', 'int', 'wis', 'cha'];
export const SENSE_TYPES = ['darkvision', 'blindsight', 'tremorsense', 'truesight'];

const abilityAliases = {
  strength: 'str', dexterity: 'dex', constitution: 'con',
  intelligence: 'int', wisdom: 'wis', charisma: 'cha',
};

export const parseSavingThrows = (value) => {
  const entries = Array.isArray(value)
    ? value.flatMap((entry) => {
      if (!entry || typeof entry !== 'object') return [];
      if (entry.name !== undefined) return [[entry.name, entry.value]];
      return Object.entries(entry);
    })
    : value && typeof value === 'object' ? Object.entries(value) : [];

  const seen = new Set();
  return entries.flatMap(([rawAbility, rawTotal]) => {
    const normalized = String(rawAbility || '').trim().toLowerCase();
    const ability = abilityAliases[normalized] || normalized;
    const total = Number(rawTotal);
    if (!SAVE_ABILITIES.includes(ability) || seen.has(ability) || !Number.isFinite(total)) return [];
    seen.add(ability);
    return [{ ability, total }];
  });
};

export const serializeSavingThrows = (rows) => Object.fromEntries(
  (Array.isArray(rows) ? rows : []).flatMap(({ ability, total }) => {
    const numeric = Number(total);
    return SAVE_ABILITIES.includes(ability) && Number.isFinite(numeric) ? [[ability, numeric]] : [];
  }),
);

export const parseSenses = (value) => {
  const source = value && typeof value === 'object' && !Array.isArray(value)
    ? value
    : typeof value === 'string' && value.trim() ? { summary: value.trim() } : {};
  const rows = [];
  const extras = {};
  let passivePerception = '';

  Object.entries(source).forEach(([rawType, rawValue]) => {
    const type = String(rawType).trim().toLowerCase();
    if (type === 'passive_perception' || type === 'passiveperception') {
      const numeric = Number(rawValue);
      if (Number.isFinite(numeric)) passivePerception = numeric;
      else extras[rawType] = rawValue;
      return;
    }
    if (SENSE_TYPES.includes(type)) {
      const match = String(rawValue ?? '').match(/^\s*(\d+(?:\.\d+)?)\s*(?:ft\.?)?(.*)$/i);
      if (match && Number(match[1]) > 0) {
        rows.push({ type, range: Number(match[1]), blindBeyond: type === 'blindsight' && /blind beyond/i.test(match[2]) });
      } else {
        extras[rawType] = rawValue;
      }
      return;
    }
    extras[rawType] = rawValue;
  });

  return { rows, passivePerception, extras };
};

export const serializeSenses = (rows, passivePerception, extras = {}) => {
  const senses = { ...extras };
  (Array.isArray(rows) ? rows : []).forEach(({ type, range, blindBeyond }) => {
    const numeric = Number(range);
    if (!SENSE_TYPES.includes(type) || !Number.isFinite(numeric) || numeric <= 0) return;
    senses[type] = `${numeric} ft.${type === 'blindsight' && blindBeyond ? ' (blind beyond this radius)' : ''}`;
  });
  if (passivePerception !== '' && Number.isFinite(Number(passivePerception))) {
    senses.passive_perception = Number(passivePerception);
  }
  return senses;
};
